import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import PrivateRoute from './components/layout/PrivateRoute';
import Layout from './components/layout/Layout';
import Login from './components/auth/Login';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Profile from './pages/Profile';
import Users from './pages/Users';
import Roles from './pages/Roles';
import Settings from './pages/Settings';

// Pages (placeholders por ahora)
const Dashboard = () => <div className="text-gray-700"><h2 className="text-2xl font-bold mb-4">Dashboard</h2><p>Bienvenido al CRM.</p></div>;

function App() {
    return (
        <BrowserRouter>
            <ThemeProvider>
                <AuthProvider>
                    <Routes>
                        {/* Rutas públicas */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />

                        {/* Rutas privadas */}
                        <Route path="/dashboard" element={
                            <PrivateRoute>
                                <Layout><Dashboard /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/profile" element={
                            <PrivateRoute>
                                <Layout><Profile /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/users" element={
                            <PrivateRoute permiso={['usuarios', 'read']}>
                                <Layout><Users /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/roles" element={
                            <PrivateRoute permiso={['roles', 'read']}>
                                <Layout><Roles /></Layout>
                            </PrivateRoute>
                        } />
                        <Route path="/settings" element={
                            <PrivateRoute roles={['superadmin', 'admin']}>
                                <Layout><Settings /></Layout>
                            </PrivateRoute>
                        } />

                        {/* Redirect default */}
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </AuthProvider>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
